<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-06-26 18:38:35
 * @LastEditTime: 2022-07-28 15:30:18
 * @LastEditors: mdb
-->
<template>
  <div class="cos-layout-main" :class="{ 'has-breadcrumb': props.isBreadcrumb }">
    <dc-breadcrumb v-bind="$attrs" v-if="isBreadcrumb" @on-click="handleClickBreadcrumb" />
    <div class="cos-layout-main__content" :class="{ streak: props.streak }">
      <slot name="content" />
    </div>
  </div>
  <div class="cos-layout-footer" v-if="hasFooterSlot">
    <dc-layout-button-group>
      <slot name="footer" />
    </dc-layout-button-group>
  </div>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue'
import { layoutTags } from '@dc-platform/dc-interaction'
import type { ComponentInternalInstance } from 'vue'
const { slots } = getCurrentInstance() as ComponentInternalInstance

const hasFooterSlot = computed(() => slots?.footer)

const props = defineProps({
  streak: Boolean,
  isBreadcrumb: {
    type: Boolean,
    default: true
  }
})

const handleClickBreadcrumb = (item: any) => {
  if (item.path) {
    layoutTags.goto(item.path)
  }
}
</script>
<script lang="ts">
export default { name: 'CosLayoutMain' }
</script>

<style lang="scss" scoped>
.cos-layout-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  background-color: #f9f9ff;
  overflow: hidden;
  &.has-breadcrumb {
    padding-top: 0;
  }
  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
    border-radius: 4px;
    background-color: #fff;
    overflow-x: hidden;
    overflow-y: auto;
    &.streak {
      padding: 20px 0;
      :deep(.ant-tabs) {
        padding: 0 20px;
      }
    }
  }
  :deep(.ant-form) {
    position: relative;
    &:not(:last-child) {
      &::after {
        position: absolute;
        left: -20px;
        bottom: 0;
        content: '';
        width: calc(100% + 40px);
        height: 12px;
        background-color: #f9f9ff;
      }
    }
    &:not(:first-child) {
      margin-top: 20px;
    }
  }
}

.cos-layout-footer {
  height: 50px;
  padding: 0 30px;
  text-align: right;
  background: #ffffff;
  box-shadow: 0 -4px 12px #1d4cd20d;
}

// /*控制整个滚动条*/
// ::-webkit-scrollbar {
//   background-color: rgb(224, 224, 224);
//   width: 6px;
//   height: 10px;
//   background-clip: padding-box;
// }

// /*滚动条中间滑动部分*/
// ::-webkit-scrollbar-thumb {
//   background-color: #acacad;
//   border-radius: 5px;
// }
</style>
